import { Grid, Tooltip} from "@mui/material";

export function getProductcompositionStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        productid:{
            name:'productid',
            label:'Product ID',
            value:'',
            error:false,
            errorMessage:'You must enter Product ID',
            required:true,
            fieldtype:'ID'
        },
        compositionname:{
            name:'compositionname',
            label:'Composition Name',
            value:'',
            error:false,
            errorMessage:'You must enter Composition Name',
            required:true,
            fieldtype:'string'
        },
        compositionid:{
            name:'compositionid',
            label:'Composition ID',
            value:'',
            error:false,
            errorMessage:'You must enter Composition ID',
            required:true,
            fieldtype:'bodynamiclist'
        },
        quantity:{
            name:'quantity',
            label:'Quantity',
            value:'',
            error:false,
            errorMessage:'You must enter Quantity',
            required:true,
            fieldtype:'string'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'compositionname', headerName: 'Composition Name', width:200 },
        { field: 'quantity', headerName: 'Quantity', width:100 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['compositionname']:{
          ...formValues['compositionname'],
          value:data.compositionname,
        },['compositionid']:{
          ...formValues['compositionid'],
          value:data.compositionid,
        },['quantity']:{
          ...formValues['quantity'],
          value:data.quantity,
        },['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },
      })
}